import {animate} from './animate';

interface AnimatedScrollUpOptions {
	to?: number;
	durationMs?: number;
}

export function animatedScrollUp({to = 0, durationMs = 300}: AnimatedScrollUpOptions = {}) {
	animate({from: window.scrollY, to, durationMs}, (tick) => {
		window.scrollTo({top: tick.value});
	});
}
